import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '~/components/Atoms/Button'
import { Tag } from '~/components/Atoms/Tag'
import { DownloadContext } from '~/components/Molecules/DownloadContext'

import report from '~/assets/report.svg'
import { Reports } from '~/types/api'

export function Banner({ data }: { data: Reports[] | undefined }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  let startDate
  let endDate
  if (data && data.length > 0) {
    const d = data[0]
    switch (d.period_label) {
      case 'annuel':
        startDate = moment(d.date).startOf('year').format('DD/MM/yyyy')
        endDate = moment(d.date).endOf('year').format('DD/MM/yyyy')
        break
      default:
        startDate = moment(d.date).format('DD/MM/yyyy')
        endDate = moment(d.date).add(3, 'months').format('DD/MM/yyyy')
        break
    }
  }

  return (
    <Box
      bgcolor={theme.palette.primary.lightest}
      borderRadius={theme.radius.M}
      display="flex"
      flexDirection="row"
      width="100%"
      padding={theme.spacing['4XL']}
      gap={theme.spacing['4XL']}
    >
      <img src={report} alt="rapport" />
      <Box display="flex" flexDirection="column" justifyContent="space-between" width="100%">
        <Tag width={'80px'} label="New" />
        <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
          <Box display="flex" flexDirection="column">
            <Typography variant="h3">{t('reports:downloadLast')}</Typography>
            <Typography variant="body">
              {t('reports:lastReport', { startDate: startDate, endDate: endDate })}
            </Typography>
          </Box>
          <Button
            variant="contained"
            label={t('common:download')}
            endIcon={<DownloadOutlinedIcon />}
            onClick={(event: MouseEvent<HTMLButtonElement>) => {
              setOpen(true)
              setAnchorEl(event.currentTarget)
            }}
          />
        </Box>
      </Box>
      <DownloadContext open={open} setOpen={setOpen} id={data && data[0]?.id} anchorEl={anchorEl} />
    </Box>
  )
}
